module.exports = __webpack_public_path__ + "static/media/advcash.203130e3.svg";